const parser = new DOMParser()

export const solAdsIFrame: HTMLElement | null = parser.parseFromString(
    `
        <div class="sol-content relative M3Ads M3MedRec2ads content-width-250 solads-slide" data-advert-slide>
            <div style="float: right; margin-bottom: 5px; display: inline-block;">
                <span class="sol-label background-lightgrey" style=" font-size: 85% !important; font-weight: 900; top: 0 !important; padding: 0 !important;">
                    <a class="sol-ads-link" href="https://www.solads.media/" target="_blank" rel="nofollow" style="font-weight: bolder;">SolAds</a>
                </span>
                <small class="sol-text-label text-white" style="display: inline !important; font-size: 85% !important;">Anzeige</small>
           </div>
        <iframe
            aria-label="SolAds"
            src="/api/plutos"
            allowtransparency="yes"
            class="sol-frame"
            width="250"
            height="250"
            id="plutos-frame"
        ></iframe>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null

export const trafficStarsGallerySlide: HTMLElement | null = parser.parseFromString(
    `<div class="sol-content relative M3Ads uncensored-banner content-width-250" data-advert-slide>
    <div class="sol-advert-mark gallery-slide-label">
        <span class="sol-label background-lightgrey" style="font-size: 85% !important; font-weight: 900; top: 0 !important; padding: 0 !important;">
            <a href="https://trafficstars.com/" target="_blank" rel="nofollow" style="font-weight: bolder;">TrafficStars</a>
        </span>
        <small class="sol-text-label text-white" style="display: inline !important; font-size: 85% !important;">Anzeige</small>
    </div>
    <div class="uncensored-banner-container gallery-slide-banner"></div>
</div>`,
    "text/html",
).body.firstElementChild as HTMLElement | null

export const adModal: HTMLElement | null = parser.parseFromString(
    `
    <div id="galleryInject">
        <div class="gallery-inject-container">
            <div id="galleryInjectAdContainer" style="padding-top: 20px;"></div>
            <div style="padding-top: 10px;">
                <a href="#" onclick="$('#galleryInject').remove(); return false;" class="button-sm ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-left ui-btn-up-b">
                    <span class="btn btn-lg btn-block btn-ladies-primary m-5-b ui-btn-inner ui-btn-corner-all">
                        <span class="ui-btn-text">Werbung schließen</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null
